<template>
<v-app>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            
            <div
              class="wizard-step"
              data-wizard-type="step" data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de la Empresa
                  </h3>
                  <div class="wizard-desc">
                    Configure datos de la empresa
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <b-form class="form" @submit.stop.prevent="onSubmit">
                
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos de la empresa
                  </h4>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Rut Empresa</label>
                        <b-form-input
                        disabled
                          class="form-control"
                          id="example-input-1"
                          name="example-input-1"
                          v-model="$v.form.rutEmpresa.$model"
                          :state="validateState('rutEmpresa')"
                          aria-describedby="input-rut-live-feedback" autofocus
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-rut-live-feedback">
                          Rut es requerido y debe ser valido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Nombre o Razón Social</label>
                    <b-form-input
                      class="form-control text-uppercase"
                      type="text"
                      id="example-input-3"
                      name="example-input-3"
                      v-model="$v.form.nombre.$model"
                      :state="validateState('nombre')"
                      aria-describedby="input-3-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-3-live-feedback">
                      Nombre es requerido.
                    </b-form-invalid-feedback>
                  </div>

                   <div class="form-group">
                    <label>ID Cliente</label>
                    <b-form-input
                      class="form-control text-uppercase"
                      type="number"
                      id="idCliente"
                      name="idCliente"
                      v-model="$v.form.idCliente.$model"
                      :state="validateState('idCliente')"
                      aria-describedby="idCliente-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="idCliente-live-feedback">
                      Nombre es requerido.
                    </b-form-invalid-feedback>
                  </div>

                  <!-- <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Empresa Activada</label>
                         <v-switch v-model="switch1"></v-switch>
                        
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div> -->

                  <div class="d-flex ">
                    <button 
                      class="btn btn-primary align-self-center"
                      type="submit"
                    >
                      Actualizar
                    </button>

                    <router-link :to="{ name: 'management-client'}" class="btn btn-primary ml-5">
                           Volver a empresas
                        </router-link>
                  </div>
                  
                  
                </div>
                <!--end: Wizard Step 1-->

                
              </b-form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</v-app>
</template>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
<style>
.transparent {
  background: transparent !important;
}
.perfil-menu {
  background: #fff;
}
.perfil-body {
  background: #fff;
}
</style>

<script>
import { mapState } from "vuex";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import { validationMixin } from "vuelidate";
import { GET_COMPANY, UPDATE_COMPANY } from "@/core/services/store/company.module";
import {
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  name: "edicionEmpresa",
  data() {
    return {
      isMounted : false,
      wizard:null,
      switch1: true,
      step:1,
       form: {
        tokenEmpresa:"",
        rutEmpresa:"",
        nombre:"",
        idCliente:"",
        activo:true
      },
      };
  },
  validations: {
    form: {
      rutEmpresa: {
        required,
      },
      nombre: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      },
      idCliente:{ }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Se ha actualizado la empresa ${this.$v.form.nombre.$model}.`, {
        title: 'Empresa actualizada exitosamente',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.actualizarEmpresa();
    },
    actualizarEmpresa(){
      const tokenEmpresa = this.companyClient.tokenEmpresa;
      const rutEmpresa = this.companyClient.rutEmpresa;
      const nombre = this.$v.form.nombre.$model;
      const idCliente = this.$v.form.idCliente.$model != null ? parseInt(this.$v.form.idCliente.$model) : null
      setTimeout(() => {
        this.$store
          .dispatch(UPDATE_COMPANY, {  tokenEmpresa, rutEmpresa, nombre: nombre.toUpperCase(), idCliente,activa:this.switch1 })
          // go to which page after successfully login
          .then(() =>{
            this.makeToast()

            this.getCompanyClient();
          }).catch(({ response }) => {
          this.$bvToast.toast(`Ha ocurrido un error al actualizar la empresa, intente nuevamente.`, {
        title: 'Error al actualizar',
        autoHideDelay: 5000,
        variant: "danger",
        toaster:"b-toaster-top-right",
        appendToast: false
      })
      console.error(response)
        });;

        /*submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );*/
      }, 500);
    },
    getCompanyClient() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_COMPANY, this.$route.params.tokenEmpresa)
          .then((response)=>{
            this.$v.form.rutEmpresa.$model = `${response.rutEmpresa}-${response.dvEmpresa}`,
          this.$v.form.nombre.$model = response.nombre,
           this.$v.form.idCliente.$model = response.idCliente,
            this.$Progress.finish()});
    },
  },
  beforeUpdate() {

      if(!this.isMounted){
        this.$nextTick(function() {
          this.$v.form.rutEmpresa.$model = `${this.companyClient.rutEmpresa}-${this.companyClient.dvEmpresa}`;
          this.$v.form.nombre.$model = this.companyClient.nombre;
            this.$v.form.idCliente.$model = this.companyClient.idCliente;
        });
        this.isMounted = true;
      }
  },
  mounted() {
    this.getCompanyClient();
    // Initialize form wizard
    this.wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    this.wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    this.wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      companyClient: state => state.company.companyClient,
      rutEmpresa: function(){
        return `${this.companyClient.rutEmpresa}-${this.companyClient.dvEmpresa}`;
      },
    })
  }
};
</script>